<div class="col-lg-12 d-flex quienes-blq-inner-int mb-flex-dir-col">
    <div class="col-lg-6 col-md-12 col-sm-12 col-12 px-lg-3 px-md-0">
        <p class="text-uppercase">{{twoColArea_params.preTitle}}</p>
        <h1>{{twoColArea_params.title}}</h1>
    </div>
    <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <p class="mt-lg-5 mt-md-0">{{twoColArea_params.mainText}}</p>
        <a class="btn btn-rco" *ngIf="twoColArea_params.mainButtonText != ''"
        routerLink="{{twoColArea_params.mainButtonLink}}"><p>
            {{twoColArea_params.mainButtonText}}</p></a>
    </div>
</div>